export default __webpack_public_path__ + "static/media/custom-head.f9b60d59.png";